module.exports = __webpack_public_path__ + "img/schedule_bg.2b118746.jpg";